import gql from "graphql-tag";

export default gql`
  mutation authenticateSSOTempUser(
    $validUntil: String
    $revokedAt: String
    $accountId: String
    $tempId: String
    $resourceId: String
    $baseUrl: String
    $link: String
    $shortCode: String
    $userRole: UserRoleTypes
    $app: SSOApps
    $appId: String
  ) {
    authenticateSSOTempUser(
      validUntil: $validUntil
      revokedAt: $revokedAt
      accountId: $accountId
      tempId: $tempId
      resourceId: $resourceId
      baseUrl: $baseUrl
      link: $link
      shortCode: $shortCode
      userRole: $userRole
      app: $app
      appId: $appId
    ) {
      token
      refreshToken
      redirectLocation
      SSOAccountRole
      email
      primaryAccountId
    }
  }
`;
